import { dictionary } from "../../../utils/dictionary";
import { useAuth } from "../../../context/AuthContext";
import CoinFluxi from "../../../assets/icons/coin-fluxi.svg";

interface CreditsBadgeProps {
  amount: number;
  label?: string;
  className?: string;
}

export function CreditsBadge({ amount, label, className }: CreditsBadgeProps) {
  const { language } = useAuth();

  return (
    <div className={`flex items-center rounded-full px-3 py-1 ${className || ""}`}>
      <span className="text-base font-semibold text-gray-900 mr-2">
        {label || dictionary["credits"][language]}:
      </span>
      <img
        src={CoinFluxi}
        alt="credits"
        className="w-5 h-5 mx-1"
        style={{ filter: "brightness(0) saturate(100%) invert(67%) sepia(54%) saturate(1000%) hue-rotate(5deg) brightness(98%) contrast(89%)" }}
      />
      <span className="text-xl font-bold text-fluxi">{amount}</span>
    </div>
  );
}
